import React, {Component} from 'react';

import WindowElement from './window-element';


export default class TypeWindow extends Component{
	handleRadioChanged = (id) => {
		this.changeNumBgImage(id);
		this.changeClassNameWindowConstruction(id);
		this.hideSalesBlock(id);
	}

	render(){
		const {pathimages, typewindowdata, mainstate, onUpdateTypeWindow} = this.props;
		const elements = typewindowdata.map((item, id) => {
			const {...itemProps} = item;
			return (
				<React.Fragment key={id}>
					<WindowElement
						{...itemProps}
						mainstate = {mainstate}
						onRadioChanged={this.handleRadioChanged}
						onUpdateTypeWindow = {onUpdateTypeWindow}
						pathimages = {pathimages}
					/>
				</React.Fragment>
			)
		});

		return (
			<div className="wincalc-type wincalc-widget">
				<div className="wincalc-title">Тип окна</div>
				<div className="d-flex justify-content-sm-between flex-wrap">
					{elements}
				</div>
			</div>
		)
	}

	// =CUSTOM FUNCTIONS
	changeNumBgImage = (id, pathimages) => {
		const NAME_IMAGE = `window-${id}-frame`;

		if  (document.querySelector('#main-frame-picture source')) {
			document.querySelector('#main-frame-picture source').srcset = `${pathimages}${NAME_IMAGE}.webp`;
			document.querySelector('#main-frame-picture img').src = `${pathimages}${NAME_IMAGE}.jpg`;
		} else{
			document.querySelector('#main-frame-picture').src = `${pathimages}${NAME_IMAGE}.jpg`;
		}
	}

	// изменяем класс обертки главной картинки
	changeClassNameWindowConstruction(id){
		document.querySelector('.wincalc-construction').className = `wincalc-construction wincalc-construction-${id}`;
	}

	// когда выбран балкон скрываем блок скидок
	hideSalesBlock(id){
		const propvalue = (id === 5) ? 'none' : 'block';
		document.querySelector('.wincalc-sales').style.display = propvalue;
	}
	// =/CUSTOM FUNCTIONS
}

